import { render, staticRenderFns } from "./ContrattoStandard.vue?vue&type=template&id=7d2e6106&"
import script from "./ContrattoStandard.vue?vue&type=script&lang=js&"
export * from "./ContrattoStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports